angular
  .module("admin")
  .controller(
    "EditUsersCtrl",
    function ($uibModalInstance, SupervisorsResource, user) {
      this.model = Object.assign({ roles: "" }, user);

      this.roles = [
        {
          id: "atendimento",
          name: "Comercial",
        },
        {
          id: "financeiro",
          name: "Financeiro",
        },
        {
          id: "publicidade",
          name: "Marketing",
        },
        {
          id: "users",
          name: "Gerenciamento de Usuários",
        },
      ];

      this.bindModelToRoles = function () {
        if (!this.model.roles.length) return;

        this.roles.forEach((r) => {
          r.selected = this.model.roles.includes(r.id.toUpperCase());
        });
      };

      this.bindRolesToModel = function () {
        this.model.roles = this.roles
          .filter((r) => r.selected)
          .map((r) => r.id);
      };

      this.bindModelToRoles();

      this.dismiss = function () {
        $uibModalInstance.dismiss();
      };

      this.savePersonalData = function (frm) {
        frm.$setSubmitted(true);

        if (frm.$invalid) return;

        this.bindRolesToModel();

        const dataToSave = {
          name: this.model.name,
          email: this.model.email,
          roles: this.model.roles,
        };

        SupervisorsResource.update(
          { id: this.model.id },
          dataToSave,
          () => {
            this.personalDataSaved = true;
            this.alerts = [];
          },
          (err) => {
            this.alerts = [
              {
                message:
                  (err.data && err.data.message) || "Erro ao editar usuário",
                type: "danger",
              },
            ];
          }
        );
      };

      this.savePassword = function (passwordFrm) {
        passwordFrm.$setSubmitted(true);

        if (passwordFrm.$invalid) return;

        const dataToSave = {
          password: this.passwordModel.password,
        };

        SupervisorsResource.changePasswordById(
          { id: this.model.id },
          dataToSave,
          () => {
            this.passwordSaved = true;
            this.passwordModel = { password: "", confirm: "" };
            passwordFrm.$setPristine();
            this.passwordAlerts = [];
          },
          (err) => {
            this.passwordAlerts = [
              {
                message:
                  (err.data && err.data.message) || "Erro ao alterar senha",
                type: "danger",
              },
            ];
          }
        );
      };

      this.close = function () {
        $uibModalInstance.close();
      };
    }
  );
